import {Placeholder} from "@/components/placeholder";

const icons = [{
    img: "/site/ficon-1.png",
    title: "正品保障",
    desc: <span>自营工厂，品质保证</span>
}, {
    img: "/site/ficon-2.png",
    title: "价格透明",
    desc: <span>全网统一 定价策略<br/>明码实价</span>
}, {
    img: "/site/ficon-3.png",
    title: "专属客服",
    desc: <span>一对一客服，快速响应</span>
}, {
    img: "/site/ficon-4.png",
    title: "价格优",
    desc: <span>价格具有吸引力<br/>不惧比价</span>
}, {
    img: "/site/ficon-5.png",
    title: "品类齐全",
    desc: <span> 100+大类<br/>一站式采购服务<br/>支持来图定制加工</span>
}];
export default function FooterIconsBox() {
    return <div className="grid grid-cols-5 gap-x-4">
        {
            icons.map((item, index) => {
                return <div className="s-flex gap-x-2 !items-start" key={index}>
                    <Placeholder src={item.img} imageWidth={40} imageHeight={40}/>
                    <div>
                        <p className="font-bold">{item.title}</p>
                        <span className="text-themeP text-[12px] block">{item.desc}</span>
                    </div>
                </div>;
            })
        }
    </div>;
}
